import * as decode from 'jwt-decode';

interface TokenDto {
  sub: string;
  exp: number;
}

function getTokenExpirationDate(token: string) {
  const decoded = decode<TokenDto>(token);

  if (!decoded || !decoded.exp) {
    throw 'Invalid JWT format.';
  }

  const date = new Date(0);
  date.setUTCSeconds(decoded.exp);

  return date;
}

export default function isJwtExpired(token: string) {
  const expDate = getTokenExpirationDate(token);
  return expDate < new Date();
}



// WEBPACK FOOTER //
// ./src/utils/isJwtExpired.ts